// eslint-disable-next-line spaced-comment
export default ({ size, color = '#000' } = {}) => /*html*/`
<svg width="${ size }" height="${ size }" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.95035 2.92769L11.451 6.51349L3.84954 14.2999L0.728473 14.6528C0.310654 14.7002 -0.04236 14.3383 0.00412516 13.9103L0.351397 10.711L7.95035 2.92769ZM13.6161 2.39383L11.9724 0.71017C11.4597 0.184989 10.6282 0.184989 10.1155 0.71017L8.56915 2.29412L12.0698 5.87991L13.6161 4.29597C14.1288 3.7705 14.1288 2.91901 13.6161 2.39383Z" fill="${ color }"/>
</svg>
`
